import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button, Card, CardBody, Field, TextInput } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("demo@odingard.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
      navigate(params.get("next") ?? "/studio");
    } catch {
      setError("Invalid email or password.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <Link to="/" className="brand" style={{ justifyContent: "center", marginBottom: "var(--ods-space-5)" }}>
          <span className="brand__mark">O</span> Odingard Studio
        </Link>
        <Card>
          <CardBody>
            <h1 style={{ fontSize: "var(--ods-text-xl)", marginTop: 0 }}>Sign in</h1>
            {error && (
              <div className="banner banner--warning" role="alert">
                {error}
              </div>
            )}
            <form onSubmit={onSubmit}>
              <Field label="Work email">
                {(id) => (
                  <TextInput id={id} type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                )}
              </Field>
              <Field label="Password">
                {(id) => (
                  <TextInput
                    id={id}
                    type="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                )}
              </Field>
              <Button type="submit" block disabled={busy}>
                {busy ? "Signing in…" : "Sign in"}
              </Button>
            </form>
            <p style={{ textAlign: "center", marginBottom: 0, fontSize: "var(--ods-text-sm)", color: "var(--ods-color-muted)" }}>
              No account? <Link to="/start">Start a free trial</Link>
              {" · "}
              <Link to="/forgot-password">Forgot password?</Link>
            </p>
          </CardBody>
        </Card>
        <p style={{ textAlign: "center", fontSize: "var(--ods-text-xs)", color: "var(--ods-color-muted)", marginTop: "var(--ods-space-4)" }}>
          Demo login: demo@odingard.com / Demo1234!
        </p>
      </div>
    </div>
  );
}
